import React, {useState} from 'react';
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {makeStyles, useTheme} from '@mui/styles';
import Spinner from "./Spinner";
import {Checkbox, Divider, FormControlLabel, List, ListItem, Paper} from "@mui/material";
import {getPrefSex, getSpacesBySex} from "../../../utils/utils";
import {useSelector} from "react-redux";


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexGrow: 1,
        marginBottom: theme.spacing(8)
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        flex: '1 0 auto',
    },
    cover: {
        width: '75%',
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    playIcon: {
        height: 38,
        width: 38,
    },
    paper: {
        padding: theme.spacing(0),
        width: '100%',
        margin: 'auto',
    },
    mainContainer: {
        padding: theme.spacing(1),
    },
    roomInfoContainer: {
        width: '100%',
        flexGrow: 10,
    },
    roomSpaces: {
        marginLeft: '8px',
    },
    roomListInfo: {
        display: 'flex',
        width: '100%',
        paddingBottom: 0,
        // paddingTop: 0,
        '-webkit-flex-direction': 'column',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        paddingTop: '20px',
    }

}));
const Room = ({roomData}) => {
    // const prefix = window['siteUrl'];
    const hasSingleOccupancy = roomData.availBeds.some(berth => berth.avail === 2);
    // Remove sex validation for Triple Staterooms (index = 5)
    const prefSex = roomData.index !== 5 ? getPrefSex(roomData.availBeds) : '';
    const {maleSpaces, femaleSpaces} = roomData.index !== 5 ? getSpacesBySex(roomData) : {
        maleSpaces: 0,
        femaleSpaces: 0
    };

    const {selectedRooms} = useSelector(state => state.transactions);

    const [singleOccupancy, setSingleOccupancy] = useState(false);
    const disabledSingle = roomData['price']['singleDisabled'] === true || (selectedRooms.filter(r => r.index === roomData.index).length || 0) > 0;
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Paper className={classes.paper} elevation={3}>
                <Grid container spacing={3} sx={{opacity: roomData['spaces'] > 0 ? 1 : '0.3'}}>
                    <Grid item xs={12} sm={7}>
                        <img src={roomData['images'][0]} alt="Room1" width={'100%'} className={'roomImage'}/>
                    </Grid>
                    <Grid item xs={12} sm={5} style={{paddingLeft: 0}}>
                        <List className={classes.roomListInfo}>
                            <ListItem className='roomDescription' alignItems="flex-start">
                                <Grid container direction="row" spacing={3}
                                      className={classes.roomInfoContainer}>
                                    <Grid item xs={12} sm={12}>
										{/* {/<\/?[a-z][\s\S]*>/i.test(roomData['title']) ?
													<span dangerouslySetInnerHTML={{__html: roomData['title']}}/>
														: roomData['title']} */}
										<Typography variant="h3" component="h2" align="left" style={{paddingLeft: 10, paddingBottom: 15, lineHeight: 1}}>
											{roomData['title']}
											{roomData?.special && Object.keys(roomData.special).length > 0 ?
												<div style={{display: 'flex', gap: '20px', marginTop: '5px'}}>
													<small style={{width: 'unset'}}>${parseFloat(roomData['special']['current']['pretax']).formatMoney()}</small>
													<small style={{width: 'unset'}}><s style={{color: '#D3240C'}}>${parseFloat(roomData['special']['prev']['pretax']).formatMoney()}</s></small>	
												</div> :
												<small>${parseFloat(roomData['price']['pretax']).formatMoney()}</small>
											}
										</Typography>
                                        <Typography variant="h5" component="h5" align="left"
                                                    style={{paddingLeft: 10, paddingBottom: 5}}>
                                            {roomData['description']}
                                        </Typography>
                                        {roomData['spaces'] > 0 && (
                                            <Typography variant="h5" component="h5" align="left"
                                                        style={{paddingLeft: 10, paddingBottom: 15}}>
                                                <strong style={{'color': roomData['spaces'] <= 4?'#e1b724':'#14aa09'}}>
                                                    {/*{(maleSpaces > 0 || femaleSpaces > 0) ?*/}
                                                    {/*    `Only ${maleSpaces > 0 ? maleSpaces + ' Male ' : ''}${femaleSpaces > 0 ? femaleSpaces + ' Female' : ''} ${roomData['spaces'] > 1 ? 'Spaces' : 'Space'} Available! (separate rooms)` : */}
                                                    {roomData['spaces'] > 0 ?`${roomData['spaces'] <= 4?'Only':''}  ${roomData['spaces']} ${roomData['spaces'] <= 4?prefSex:''} ${roomData['spaces'] > 1 ? 'Berths' : 'Berth'} Available!` : 'No Berths Available'}
                                                </strong>
                                            </Typography>)}
                                        {roomData.index !== 5 && hasSingleOccupancy && roomData['spaces'] > 0 &&
                                            <FormControlLabel
                                                className={'cleanCheckbox'}
                                                control={
                                                    <Checkbox checked={singleOccupancy}
                                                              onChange={() => setSingleOccupancy(!singleOccupancy)}
                                                              name="singleOccupancy"
                                                              color="primary"
                                                              disabled={disabledSingle}
                                                    />
                                                }
                                                label="I want single occupancy"/>}
                                    </Grid>
                                </Grid>
                            </ListItem>
                            <Divider variant="fullWidth" className={'dividerFullWidth'}/>
                            {roomData['spaces'] > 0 && <ListItem style={{paddingTop: 8, paddingBottom: 8}}>
                                <Grid item md={6}>
                                    <Typography component="h4" variant="h4" align="left"
                                                style={{marginLeft: 8, fontSize: '1.6rem'}}>
                                        Number of Spaces
                                    </Typography>
                                </Grid>
                                <Grid item md={6} container justifyContent={"center"} alignItems={"center"}>
                                    <Spinner index={roomData['index']} singleOccupancy={singleOccupancy}/>
                                </Grid>
                            </ListItem>}
                        </List>
                    </Grid>
                </Grid>
            </Paper>
        </div>
    );
}

export default Room;
